import React, { useEffect, useState } from "react";
import { Accordion } from "react-bootstrap";
import Dropdown from "react-dropdown";
import { Dropdown as BSDropdown } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { LoadingOverlay, Loader } from "react-overlay-loader";

import { DropOffLinkTypeLabels, MessageOptionsConstants, SupportContactsConstants, userSettingsConstant } from "../../../helper/Constants";
import { ApplicationState } from "../../../store";
import {
    fetchAuthenticationMethodSettings,
    fetchContactList,
    fetchDropOffSettings,
    fetchOfficeLocationList,
    fetchRetentionSettings,
    fetchSupportContactSettings,
    requestAllRetentionPeriods,
} from "../../../actionCreators/adminSettingsActionCreators";
import { actionTypes } from "../../../types/userSettingsTypes";
import { getCompanyAuthMethods, getDropOffLinkTypes, sortContactsByFullName, sortLocationsByName } from "../../../helper/HelperFunctions";
import "./styles.scss";
import { requestDropOffRecipientsList } from "../../../actionCreators/dropOffActionCreators";
import { IOfficeLocation, ISupportContact, ISupportContactSettingsValues } from "../../../reducers/adminSettingsReducer";
import SearchInput from "../../common/ui/SearchInput";
import { fetchUserSettings } from "../../../actionCreators/userSettingsActionCreators";
import { IUserSettingsModel } from "../../../core/viewModels/user/UserViewModel";

interface IRententionPeriodState {
    // loginTransfer: OptionType;
    questionAndAnswer: OptionType;
    accessCode: OptionType;
    folders: OptionType;
}

type OptionType = { value: string; label: string } | undefined;

const initialOptionType = {
    value: "1",
    label: "1 Day",
};

const MessageOptions: React.FC = () => {
    const dispatch = useDispatch();
    const { messageOptions: messageOptionsSettings, dropOffSettings } = useSelector(
        (appState: ApplicationState) => appState.adminSettingsState
    );
    const user = useSelector((state: ApplicationState) => state.userProfile);
    const dropOffRecipients = useSelector(
        (state: ApplicationState) => state.dropOffState.dropOffRecipientsData.dropOffRecipients
    );
    const isPersonaLinkDisabled = !dropOffRecipients.find(recipient => recipient.userId === user.userId)
        ?.isDropOffEnabled;
    const { userSettings, isLoading } = useSelector((appState: ApplicationState) => appState.userSettingsState);
    const retentionOptions = Array.isArray(messageOptionsSettings.retentionPeriodList)
        ? messageOptionsSettings.retentionPeriodList?.map(rp => {
            return { value: rp.retentionId.toString(), label: rp.description };
        })
        : [];

    const authenticationMethodOptions = messageOptionsSettings.authenticationSettings?.authenticationMethods?.map(
        value => {
            const option = getCompanyAuthMethods().filter(method => method.value === value.toString());
            return option[0];
        }
    );

    const noUserOption = { firstName: "No User", lastName: "", userId: 0, emailAddress: "" };
    const [contactList, setContactList] = useState<ISupportContact[]>([]);
    const dropOffLinkTypes = getDropOffLinkTypes();
    const [selectedAuthenticationMethod, setSelectedAuthenticationMethod] = useState("");
    const [selectedDropOffLinkType, setSelectedDropOffLinkType] = useState("");
    const [searchText, setSearchText] = useState<string>("");
    const [officeLocationList, setOfficeLocationList] = useState<IOfficeLocation[]>([]);
    const [searchTextOfficeLocation, setSearchTextOfficeLocation] = useState<string>("");
    const [selectedContact, setSelectedContact] = useState<ISupportContact>({
        firstName: "",
        lastName: "",
        emailAddress: "",
        userId: 0,
    });
    const [selectedOfficeLocation, setSelectedOfficeLocation] = useState<IOfficeLocation>({
        name: "",
        locationId: 0,
        isPrimary: false
    });

    const [retentionPeriodState, setRetentionPeriodState] = useState<IRententionPeriodState>({
        // loginTransfer: initialOptionType,
        questionAndAnswer: initialOptionType,
        accessCode: initialOptionType,
        folders: initialOptionType,
    });

    const [updateRetentionPeriod, setUpdateRetentionPeriod] = useState(0);
    const [updateAuthenticationSettings, setUpdateAuthenticationSettings] = useState(false);


    const [supportContactList, setSupportContactList] = useState<ISupportContact[]>([]);
    const [supportContactSettings, setSupportContactSettings] = useState<ISupportContactSettingsValues | null>(null);
    const [filteredContactList, setFilteredContactList] = useState<any>([]);
    const [filteredOfficeList, setFilteredOfficeList] = useState<any>([]);

    useEffect(() => {
        dispatch(fetchOfficeLocationList((locations: IOfficeLocation[]) => {
            setOfficeLocationList(locations);
            const sortedLocations = sortLocationsByName(locations);
            setFilteredOfficeList(sortedLocations);

            dispatch(fetchSupportContactSettings((settings: ISupportContactSettingsValues) => {
                setSupportContactSettings(settings);
            }));

            dispatch(fetchUserSettings((settings: IUserSettingsModel) => {
                dispatch(fetchContactList(settings?.supportContactSettings?.locationId, (contacts: ISupportContact[]) => {
                    setSupportContactList(contacts);
                    let sortedContacts = sortContactsByFullName(contacts);
                    sortedContacts = [noUserOption, ...sortedContacts];
                    setFilteredContactList(sortedContacts);
                }));
            }));
        }));
    }, []);

    useEffect(() => {
        if (filteredOfficeList.length > 0) {
            if (userSettings && userSettings?.supportContactSettings?.locationId && supportContactSettings?.allowEmployeesToChangeSupportContact) {
                const selectedLocation = filteredOfficeList.find((data: IOfficeLocation) => data.locationId === userSettings?.supportContactSettings?.locationId);
                if (selectedLocation) {
                    setSelectedOfficeLocation(selectedLocation);
                }
                else {
                    setPrimaryLocation();
                }
            }
            else {
                //set Office location from the Contact Support tab if user has not set it in Message options dialog
                const selectedLocation = filteredOfficeList.find((data: IOfficeLocation) => data.locationId === supportContactSettings?.locationId);
                if (selectedLocation) {
                    setSelectedOfficeLocation(selectedLocation);
                }
                else {
                    setPrimaryLocation();
                }
            }
        }

    }, [filteredOfficeList, userSettings?.supportContactSettings?.locationId, supportContactSettings?.locationId]);

    useEffect(() => {
        if (filteredContactList.length > 0) {
            setContactList([noUserOption, ...supportContactList]);
            let defaultContact: any = noUserOption;
            if (userSettings && userSettings?.supportContactSettings?.contactId != null && supportContactSettings?.allowEmployeesToChangeSupportContact) {

                if (userSettings?.supportContactSettings?.contactId !== 0) {
                    defaultContact = filteredContactList.find((data: ISupportContact) => data.userId === userSettings?.supportContactSettings?.contactId);
                }
            }
            else {
                //set Support Contact from the Contact Support tab if user has not set it in Message options dialog            
                if (supportContactSettings?.supportContactId !== 0) {
                    defaultContact = filteredContactList.find((data: ISupportContact) => data.userId === supportContactSettings?.supportContactId);
                }
            }

            if (!defaultContact) {
                defaultContact = filteredContactList.filter((p: ISupportContact) => p.isPrimary)[0];
            }

            setSelectedContact(defaultContact);
        }
    }, [userSettings?.supportContactSettings?.contactId, supportContactSettings?.supportContactId, filteredContactList]);

    useEffect(() => {
        dispatch(requestAllRetentionPeriods(true));
        dispatch(fetchAuthenticationMethodSettings());
        dispatch(fetchRetentionSettings());
        dispatch(fetchDropOffSettings());
        dispatch(requestDropOffRecipientsList());
    }, []);

    useEffect(() => {
        if (
            retentionPeriodState &&
            // retentionPeriodState.loginTransfer?.value &&
            retentionPeriodState.questionAndAnswer?.value &&
            retentionPeriodState.accessCode?.value &&
            retentionPeriodState.folders?.value &&
            updateRetentionPeriod > 0
        ) {
            const payloadData = {
                // loginTransfer: parseInt(retentionPeriodState.loginTransfer["value"]),
                questionAndAnswer: parseInt(retentionPeriodState.questionAndAnswer["value"]),
                accessCode: parseInt(retentionPeriodState.accessCode["value"]),
                folders: parseInt(retentionPeriodState.folders["value"]),
            };
            dispatch({
                type: actionTypes.UPDATE_USER_SETTINGS,
                payload: {
                    ...userSettings,
                    retentionSettings: {
                        defaultRetentionPeriods: payloadData,
                    },
                },
            });
        }
    }, [updateRetentionPeriod]);

    useEffect(() => {
        if (userSettings?.retentionSettings?.defaultRetentionPeriods && messageOptionsSettings.retentionSettings && updateRetentionPeriod === 0) {
            const allowUserToChangeFolderRetentionPeriod = messageOptionsSettings.retentionSettings?.isUserAllowedToChangeFolderRetentionPeriod;
            const allowUserToChangeMessageAndDRRetentionPeriod = messageOptionsSettings.retentionSettings?.isUserAllowedToChangeMessageAndDRRetentionPeriod;

            let folderRetentionPeriod;
            let qaRetentionPeriod;
            let accessCodeRetentionPeriod;

            if (allowUserToChangeFolderRetentionPeriod) {
                // User default retention period
                folderRetentionPeriod = getSelectedOption(userSettings.retentionSettings.defaultRetentionPeriods.folders || messageOptionsSettings.retentionSettings.defaultRetentionPeriods.folders);
            } else {
                // Admin default retention period
                folderRetentionPeriod = getSelectedOption(messageOptionsSettings.retentionSettings.defaultRetentionPeriods.folders);
            }

            if (allowUserToChangeMessageAndDRRetentionPeriod) {
                // User default retention period
                qaRetentionPeriod = getSelectedOption(userSettings.retentionSettings.defaultRetentionPeriods.questionAndAnswer);
                accessCodeRetentionPeriod = getSelectedOption(userSettings.retentionSettings.defaultRetentionPeriods.accessCode);
            } else {
                // Admin default retention period
                qaRetentionPeriod = getSelectedOption(messageOptionsSettings.retentionSettings.defaultRetentionPeriods.questionAndAnswer);
                accessCodeRetentionPeriod = getSelectedOption(messageOptionsSettings.retentionSettings.defaultRetentionPeriods.accessCode);
            }

            setRetentionPeriodState({
                ...retentionPeriodState,
                folders: folderRetentionPeriod,
                questionAndAnswer: qaRetentionPeriod,
                accessCode: accessCodeRetentionPeriod,
            });
        }
    }, [userSettings?.retentionSettings?.defaultRetentionPeriods, messageOptionsSettings?.retentionSettings, messageOptionsSettings?.retentionPeriodList]);

    useEffect(() => {
        if (userSettings && userSettings.authenticationMethodSettings) {
            const methodOptions = messageOptionsSettings.authenticationSettings.authenticationMethods;
            const userDefaultMethod = userSettings.authenticationMethodSettings.defaultAuthenticationMethod;
            const adminDefaultMethod = messageOptionsSettings.authenticationSettings.defaultAuthenticationMethod;
            const allowUserToChange = messageOptionsSettings.authenticationSettings.allowEmployeesToChangeDefaultMethod;
            if (methodOptions?.includes(userDefaultMethod) && allowUserToChange) {
                setSelectedAuthenticationMethod(userDefaultMethod.toString());
            } else {
                setSelectedAuthenticationMethod(adminDefaultMethod?.toString());
            }
        }
    }, [
        userSettings?.authenticationMethodSettings?.defaultAuthenticationMethod,
        messageOptionsSettings.authenticationSettings,
    ]);

    useEffect(() => {
        if (selectedAuthenticationMethod) {
            dispatch({
                type: actionTypes.UPDATE_USER_SETTINGS,
                payload: {
                    ...userSettings,
                    authenticationMethodSettings: {
                        defaultAuthenticationMethod: parseInt(selectedAuthenticationMethod),
                    },
                },
            });
        }
    }, [updateAuthenticationSettings]);

    useEffect(() => {
        userSettings &&

            userSettings?.dropOffSettings &&
            setSelectedDropOffLinkType(userSettings?.dropOffSettings?.dropOffLinkType.toString());
    }, [userSettings?.dropOffSettings?.dropOffLinkType]);

    const setPrimaryLocation = () => {
        const primaryLocation = filteredOfficeList.find((l: IOfficeLocation) => l.isPrimary === true);

        if (primaryLocation) {
            setSelectedOfficeLocation(primaryLocation);
        }
    };

    const getSelectedOption = (value: number): OptionType => {
        const val = value.toString();
        return retentionOptions.find(rp => rp.value === val);
    };

    const handleRetentionPeriodDropDownClick = (option: any, selectedDropDown: string) => {
        setRetentionPeriodState({
            ...retentionPeriodState,
            [selectedDropDown]: option,
        });
        setUpdateRetentionPeriod(updateRetentionPeriod + 1);
    };

    const handleAuthMethodDropDownClick = (option: any) => {
        setSelectedAuthenticationMethod(option.value);
        setUpdateAuthenticationSettings(!updateAuthenticationSettings);
    };

    const handleDropOffDropDownClick = (option: any) => {

        if (option.value === DropOffLinkTypeLabels.PERSONAL && isPersonaLinkDisabled) {
            return;
        } else {
            setSelectedDropOffLinkType(option.value);
            dispatch({
                type: actionTypes.UPDATE_USER_SETTINGS,
                payload: {
                    ...userSettings,
                    dropOffSettings: {
                        ...userSettings?.dropOffSettings,
                        dropOffLinkType: parseInt(option.value),
                    },
                },
            });
        }
    };


    const onOfficeLocationChange = (e: any) => {
        const location = filteredOfficeList.find((data: IOfficeLocation) => `contact-${data.locationId}` === e.target.id);

        if (location) {
            setSelectedOfficeLocation(location);
            dispatch(fetchContactList(location.locationId, (contacts: ISupportContact[]) => {
                setSupportContactList(contacts);
                const sortedContacts = sortContactsByFullName(contacts);
                setFilteredContactList([noUserOption, ...sortedContacts]);

                const primaryAdmin = [...sortedContacts].find(contact => {
                    if (contact?.isPrimary) {
                        return contact;
                    }
                });

                if (primaryAdmin) {
                    setSelectedContact(primaryAdmin);
                } else {
                    setSelectedContact(noUserOption);
                }

                dispatch({
                    type: actionTypes.UPDATE_USER_SETTINGS,
                    payload: {
                        ...userSettings,
                        supportContactSettings: {
                            contactId: primaryAdmin?.userId ?? noUserOption.userId,
                            locationId: parseInt(location.locationId.toString()),
                        },
                    },
                });
            }));
        }
    };


    const onContactChange = (e: any) => {
        let contact: any = null;
        if (e.target.id == "contact-0") {
            contact = noUserOption;
        }
        else {
            contact = supportContactList.find(
                (data: ISupportContact) => `contact-${data.userId}` === e.target.id
            );
        }


        if (contact) {
            setSelectedContact(contact);

            dispatch({
                type: actionTypes.UPDATE_USER_SETTINGS,
                payload: {
                    ...userSettings,
                    supportContactSettings: {
                        contactId: parseInt(contact.userId.toString()),
                        locationId: parseInt(selectedOfficeLocation?.locationId.toString()),
                    },
                },
            });
        }
    };

    const getName = (contact: ISupportContact): string => `${contact?.firstName} ${contact?.lastName || ""}`;

    const onFilter = (e: any) => {
        const value = e.target.value;
        setSearchText(value);
        const filteredList = contactList.filter((data: ISupportContact) => {
            if (value.toLocaleLowerCase().trim() != noUserOption.firstName.toLocaleLowerCase().trim()) {
                return `${getName(data).toLocaleLowerCase()}`.includes(value.toLocaleLowerCase());
            }
            else {
                return false;
            }
        });
        setFilteredContactList(filteredList);
    };

    const onFilterOfficeLocation = (e: any) => {
        const value = e.target.value;
        setSearchTextOfficeLocation(value);
        let filteredList = officeLocationList.filter(data =>
            `${data?.name.toLocaleLowerCase()}`.includes(value.toLocaleLowerCase())
        );
        filteredList = sortLocationsByName(filteredList);
        setFilteredOfficeList(filteredList);
    };

    return (
        <LoadingOverlay>
            <div className="message-options-parent-container">
                <header>
                    <h3>{MessageOptionsConstants.MESSAGE_OPTIONS_TITLE_TEXT}</h3>
                    <span>{MessageOptionsConstants.MESSAGE_OPTIONS_HELPER_TEXT}</span>
                </header>
                <div className="settings-accordian-container">
                    <Accordion flush className="settings-accordian">
                        <Accordion.Item eventKey="0">
                            <Accordion.Header>
                                <div className="accordion-title-info-container">
                                    <h4>{MessageOptionsConstants.AUTHENTICATION_METHOD}</h4>
                                    <span>{MessageOptionsConstants.AUTHENTICATION_METHOD_HELPER_TEXT}</span>
                                </div>
                            </Accordion.Header>
                            <Accordion.Body>
                                <div className="settings-label-dropdown-wrapper user-settings-dropdown-wrapper">
                                    <h5>Default Method</h5>

                                    <Dropdown
                                        className="secondary-dropdown"
                                        onChange={option => {
                                            handleAuthMethodDropDownClick(option);
                                        }}
                                        placeholder="Select"
                                        disabled={
                                            !messageOptionsSettings.authenticationSettings
                                                .allowEmployeesToChangeDefaultMethod
                                        }
                                        options={authenticationMethodOptions}
                                        value={selectedAuthenticationMethod}
                                    />
                                </div>
                            </Accordion.Body>
                        </Accordion.Item>
                        <Accordion.Item className="second-accordian-item" eventKey="1">
                            <Accordion.Header>
                                <div className="accordion-title-info-container">
                                    <h4>{MessageOptionsConstants.RETENTION_PERIOD}</h4>
                                    <span>{MessageOptionsConstants.RETENTION_PERIOD_HELPER_TEXT}</span>
                                </div>
                            </Accordion.Header>
                            <Accordion.Body>
                                <div className="settings-label-dropdown-wrapper user-settings-dropdown-wrapper">
                                    <h5>{MessageOptionsConstants.RETENTION_PERIOD_QNA}</h5>

                                    <Dropdown
                                        className={`setting-dropdown ${!messageOptionsSettings.retentionSettings?.isUserAllowedToChangeMessageAndDRRetentionPeriod ? "disabled" : ""}`}
                                        onChange={option => {
                                            handleRetentionPeriodDropDownClick(option, "questionAndAnswer");
                                        }}
                                        placeholder="Select Retention Period"
                                        options={retentionOptions}
                                        value={retentionPeriodState.questionAndAnswer}
                                        disabled={!messageOptionsSettings.retentionSettings?.isUserAllowedToChangeMessageAndDRRetentionPeriod}
                                    />
                                </div>

                                <div className="settings-label-dropdown-wrapper user-settings-dropdown-wrapper">
                                    <h5>{MessageOptionsConstants.RETENTION_PERIOD_ACCESS_CODE}</h5>

                                    <Dropdown
                                        className={`setting-dropdown ${!messageOptionsSettings.retentionSettings?.isUserAllowedToChangeMessageAndDRRetentionPeriod ? "disabled" : ""}`}
                                        onChange={option => {
                                            handleRetentionPeriodDropDownClick(option, "accessCode");
                                        }}
                                        placeholder="Select Retention Period"
                                        options={retentionOptions}
                                        value={retentionPeriodState.accessCode}
                                        disabled={!messageOptionsSettings.retentionSettings?.isUserAllowedToChangeMessageAndDRRetentionPeriod}
                                    />
                                </div>

                                <div className="settings-label-dropdown-wrapper user-settings-dropdown-wrapper">
                                    <h5>{MessageOptionsConstants.RETENTION_PERIOD_FOLDERS}</h5>

                                    <Dropdown
                                        className={`setting-dropdown ${!messageOptionsSettings.retentionSettings?.isUserAllowedToChangeFolderRetentionPeriod ? "disabled" : ""}`}
                                        onChange={option => {
                                            handleRetentionPeriodDropDownClick(option, "folders");
                                        }}
                                        placeholder="Select Retention Period"
                                        options={retentionOptions}
                                        value={retentionPeriodState.folders}
                                        disabled={!messageOptionsSettings.retentionSettings?.isUserAllowedToChangeFolderRetentionPeriod}
                                    />
                                </div>

                            </Accordion.Body>
                        </Accordion.Item>
                        <div className={!dropOffSettings?.isPersonalDropOffLinkToDisplay ? "isDisabled" : ""}>
                            <Accordion.Item className="second-accordian-item first-accordian" eventKey="2">
                                <Accordion.Header
                                    style={{
                                        pointerEvents: `${!dropOffSettings?.isPersonalDropOffLinkToDisplay ? "none" : "auto"
                                            }`,
                                    }}
                                >
                                    <div className="accordion-title-info-container">
                                        <h4>{MessageOptionsConstants.DROP_OFF_LINKS}</h4>
                                        <span>{MessageOptionsConstants.DROP_OFF_LINKS_HELPER_TEXT}</span>
                                    </div>
                                </Accordion.Header>
                                {dropOffSettings?.isPersonalDropOffLinkToDisplay && (
                                    <Accordion.Body>
                                        <div className="settings-label-dropdown-wrapper user-settings-dropdown-wrapper">
                                            <h5>{MessageOptionsConstants.SELECT_DROP_OFF_LINK}</h5>

                                            <Dropdown
                                                className={`secondary-dropdown ${isPersonaLinkDisabled ? "dropdown-values-disabled-container" : ""
                                                    }`}
                                                onChange={option => {
                                                    handleDropOffDropDownClick(option);
                                                }}
                                                placeholder="Select"
                                                disabled={!dropOffSettings.isUsersAllowedToManageDropOffLink}
                                                options={dropOffLinkTypes}
                                                value={selectedDropOffLinkType}
                                            />
                                        </div>
                                    </Accordion.Body>
                                )}
                            </Accordion.Item>
                        </div>

                        <Accordion.Item className="second-accordian-item" eventKey="3">
                            <Accordion.Header>
                                <div className="accordion-title-info-container">
                                    <h4>{SupportContactsConstants.SUPPORT_CONTACT_TITLE_TEXT}</h4>
                                    <span>{SupportContactsConstants.SUPPORT_CONTACT_HELP_TEXT_LINE3}</span>
                                </div>
                            </Accordion.Header>
                            <Accordion.Body>


                                <section className="margin-top-10-px">
                                    <div className="support-contact-wrapper contact-label-dropdown-wrapper">
                                        <h4 className="heading-black-md"> {SupportContactsConstants.SUPPORT_CONTACT_DROP_DOWN_OFFICE_LOCATION_TEXT}</h4>

                                        <BSDropdown
                                            className={`btn-support-contact ${!supportContactSettings?.allowEmployeesToChangeSupportContact ? "dropdown-values-disabled-container" : ""}`}
                                            style={{ marginLeft: "129px" }}>
                                            <BSDropdown.Toggle className="dropdown-toggle">
                                                <p
                                                    title={selectedOfficeLocation ? selectedOfficeLocation.name : filteredOfficeList[0]?.name}
                                                    className="overflowText"
                                                >
                                                    {selectedOfficeLocation ? selectedOfficeLocation.name : filteredOfficeList[0]?.name}
                                                </p>
                                            </BSDropdown.Toggle>

                                            <BSDropdown.Menu className="support-contact-dropdown-menu">
                                                <div className="dropdown-search">
                                                    <SearchInput placeholder="Search" value={searchTextOfficeLocation} onChange={onFilterOfficeLocation} />
                                                </div>
                                                <div>
                                                    {filteredOfficeList.length > 0 ? (
                                                        filteredOfficeList.map((data: IOfficeLocation) => (
                                                            <BSDropdown.Item
                                                                title={data?.name}
                                                                id={`contact-${data.locationId}`}
                                                                eventKey={data.locationId}
                                                                key={data.locationId}
                                                                className={
                                                                    (selectedOfficeLocation?.locationId === data.locationId ? "selected-contact" : "") +
                                                                    " overflowText"
                                                                }
                                                                onClick={e => onOfficeLocationChange(e)}
                                                            //data-email={data.emailAddress}
                                                            >
                                                                {data.name}
                                                            </BSDropdown.Item>
                                                        ))
                                                    ) : (
                                                        <BSDropdown.Item>{userSettingsConstant.NO_LOCATION_FOUND_TEXT}</BSDropdown.Item>
                                                    )}
                                                </div>
                                            </BSDropdown.Menu>
                                        </BSDropdown>
                                    </div>
                                </section>
                                <section className="">
                                    <div className="support-contact-wrapper contact-label-dropdown-wrapper">
                                        <h4 className="heading-black-md">{SupportContactsConstants.SUPPORT_CONTACT_DROP_DOWN_TEXT}</h4>

                                        <BSDropdown
                                            className={`btn-support-contact ${!supportContactSettings?.allowEmployeesToChangeSupportContact ? "dropdown-values-disabled-container" : ""}`}
                                            style={{ marginLeft: "121px" }}>
                                            <BSDropdown.Toggle>
                                                <p
                                                    title={selectedContact ? getName(selectedContact) : getName(supportContactList[0])}
                                                    className="overflowText"
                                                >
                                                    {selectedContact ? getName(selectedContact) : getName(supportContactList[0])}
                                                </p>
                                            </BSDropdown.Toggle>

                                            <BSDropdown.Menu className="support-contact-dropdown-menu">
                                                <div className="dropdown-search">
                                                    <SearchInput placeholder="Search" value={searchText} onChange={onFilter} />
                                                </div>
                                                <div>
                                                    {filteredContactList.length > 0 ? (
                                                        filteredContactList.map((data: ISupportContact) => (
                                                            <BSDropdown.Item
                                                                title={getName(data)}
                                                                id={`contact-${data.userId}`}
                                                                eventKey={data.userId}
                                                                key={data.userId}
                                                                className={
                                                                    (selectedContact?.userId === data.userId ? "selected-contact" : "") +
                                                                    " overflowText"
                                                                }
                                                                onClick={e => onContactChange(e)}
                                                                data-email={data.emailAddress}
                                                            >
                                                                {getName(data)}
                                                            </BSDropdown.Item>
                                                        ))
                                                    ) : (
                                                        <BSDropdown.Item>{userSettingsConstant.NO_DELEGATEE_TEXT}</BSDropdown.Item>
                                                    )}
                                                </div>
                                            </BSDropdown.Menu>
                                        </BSDropdown>
                                    </div>
                                </section>
                            </Accordion.Body>
                        </Accordion.Item>
                    </Accordion>
                </div>
            </div>
            <Loader loading={isLoading} />
        </LoadingOverlay>
    );
};

export default MessageOptions;
